import { trimAndAddAsterisk } from '../../utility/QueryUtility';
import { commonDateParamMappings } from '../common/mappings';

export const NOTES_QUERY_PARAM_MAPPING = [
  ...commonDateParamMappings,
  { path: 'accountId' },
  { path: 'quoteId' },
  { path: 'page' },
  { path: 'size' },
  { path: 'dateFilter' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: { orderBy: string; order: string }) => {
      if (orderBy && order) {
        switch (orderBy) {
          case 'createdBy':
          case 'noteType':
            return `${orderBy}.keyword,${order}`;
          default:
            return `${orderBy},${order}`;
        }
      }
      return null;
    },
  },
  {
    path: 'search',
    transform: ({ search = '' }) =>
      !search ? search : trimAndAddAsterisk(search),
  },
  { path: 'f', paramKey: 'filter' },
];
